import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class Currency extends Component {

  state = {
    typingTimeout:0,
    typing:false
  }

  fieldOnChangeHandler(e){
    const {changeHandler} = this.props;
    let input_value = e.target.value.replace(/(\.\%)/,''); 
    if((input_value.search(/^[0]{1,}[\d]/)!==-1 || // takes care of leading zeroes
      //input_value.search(/^[-]?(\d+)?([\.])?([\d]{1,})?([\%])?$/)===-1) &&  //main pattern
      input_value.search(/^[-]?(\d+)?([\.])?([\d]{1,})?([])?$/)===-1) &&  //main pattern
      input_value!==''){
      e.target.value  = (this.input_prev_value!==undefined)?this.input_prev_value:'';
       changeHandler(e.target.value);
      //  this.toFixedHandler();
    }else {  
        e.target.value = (input_value!==undefined)?input_value:'';
        this.input_prev_value = e.target.value;
        changeHandler(e.target.value);
        // this.toFixedHandler();
    }
  } 
  toFixedHandler = () =>{
    let {value} = this.props;
    const decimal = (this.props.decimal!==null)? this.props.decimal :2;
    value = (value)?value:0;
    // return parseFloat(value).toFixed(decimal);
    const self = this;
    const selfProps = this.props;
    if (self.state.typingTimeout) {
        clearTimeout(self.state.typingTimeout);
    }
    self.setState({
        typing: false,
        typingTimeout: setTimeout(function () {
            selfProps.changeHandler(parseFloat(value).toFixed(decimal));
            }, 1000)
    });
  }

  
  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    
    return (
      <Wrp>
        <input 
          type="text"
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}
        />
      </Wrp>        
    );
  }
}

Currency.defaultProps = {
  isMandatory:false,
  className: 'form-control'
}

export default Currency;